import { combineReducers } from "@reduxjs/toolkit";

import userInfoReducer from "../userInfo/userInfoSlice";
import porAsinListReducer from "../porAsinList/porAsinListSlice";
import porAsinPageControlReducer from "../porAsinPageControl/porAsinPageControl";
import asinValidationTableControlReducer from "../validation/asinValidationTableConnector";
import asinBaselineTableControlReducer from "../dateBaseline/baselineTableConnector";
import asinMarketplaceBaselineCandidates from "../dateBaseline/candidateDatesConnector";
import generateQueryReducer from "../searchSideBar/searchSideBarConnector";
// import fileImportConnectorReducer from "../porImport/porImportConnnector";
import notificationConnectorReducer from "../notification/notificationConnector";
import cacheableNotificationConnectorReducer from "../notification/cacheableNotificationConnector";
import upstreamAttributesDataReducer from "../searchSideBar/upstreamAttributesConnector";
import filterWithAggregatedDataReducer from "../searchSideBar/filterWithAggregatedDataConnector";
import productLinesDataReducer from "../searchSideBar/productLinesConnector";
import validationModalStateReducer from "../validation/validationAttributeModalConnector";
import asinOneClickLaunchTableControl from "../oneClickLaunch/oneClickLaunchTableConnector";
import oneClickLaunchConnector from "../oneClickLaunch/oneClickLaunchConnector";
import oneClickLaunchModalConnector from "../oneClickLaunch/oneClickLaunchModalConnector";
import oneClickLaunchSubmissionToolsControlReducer from "../oneClickLaunch/oneClickLaunchSubmissionToolsConnector";
import milestoneScheduleTableConnector from "../dateBaseline/milestoneScheduleTableConnector";
import stamperWizardStateReducer from "../stampUtils/stamperWizardConnector";

const rootReducer = () =>
  combineReducers({
    userInfo: userInfoReducer,
    porAsinList: porAsinListReducer,
    porAsinPageControl: porAsinPageControlReducer,
    asinValidationTableControl: asinValidationTableControlReducer,
    asinBaselineTableControl: asinBaselineTableControlReducer,
    asinOneClickLaunchTableControl: asinOneClickLaunchTableControl,
    oneClickLaunchSubmissionToolsControl:
      oneClickLaunchSubmissionToolsControlReducer,
    generateQuery: generateQueryReducer,
    // fileImportConnector: fileImportConnectorReducer,
    notification: notificationConnectorReducer,
    cacheableNotification: cacheableNotificationConnectorReducer,
    upstreamAttributesData: upstreamAttributesDataReducer,
    filterWithAggregatedData: filterWithAggregatedDataReducer,
    productLines: productLinesDataReducer,
    validationModal: validationModalStateReducer,
    candidateDates: asinMarketplaceBaselineCandidates,
    oneClickLaunch: oneClickLaunchConnector,
    oneClickLaunchModal: oneClickLaunchModalConnector,
    milestoneScheduleState: milestoneScheduleTableConnector,
    stamperWizard: stamperWizardStateReducer,
  });

export type RootState = ReturnType<ReturnType<typeof rootReducer>>;

export default rootReducer;
